import { createBrowserHistory } from "history";
import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import './App.css';
import { checkLoggedIn, isLoggedIn } from "./api";
import { LoginPage } from "./pages/Login";
import { PhotosPage } from "./pages/Photos";
import { PrintPhotos } from "./pages/PrintPhotos";
import { Photo } from "./models_generated";
import { PhotoPage } from "./pages/Photo";
import { PublicCategories } from "./pages/PublicCategories";
import { PublicCategoryPhotos } from "./pages/PublicCategoryPhotos";
import { PublicPhoto } from "./pages/PublicPhoto";

const HISTORY = createBrowserHistory();

function App() {
  let [loggedIn, setLoggedIn] = useState(undefined as boolean | undefined);

  useEffect(() => {
    (async () => {
      setLoggedIn(await isLoggedIn());
    })();
  }, []);

  useEffect(() => {
    setTimeout(checkLoggedIn, 30 * 1000);
  }, []);

  let [resp, setResp] = useState("");
  const onLoggedIn = useCallback((email: string) => {
    alert(`Dobrodošli ${email}`)
    setLoggedIn(true);
  }, []);


  if (loggedIn === undefined) {
    return <p>Loading</p>;
  }

  return (
    <Router>
      <Routes>
        {/* Public routes - NO auth required */}
        <Route path="/:root/public" element={<PublicCategories />} />
        <Route path="/:root/public/category/:categoryId" element={<PublicCategoryPhotos />} />
        <Route path="/:root/public/photo/:id" element={<PublicPhoto />} />

        {/* Private routes - auth required */}
        {loggedIn ? (
          <>
            <Route path="/:root" element={<PhotosPage />} />
            <Route path="/:root/print" element={<PrintPhotos />} />
            <Route path="/:root/photo/:id" element={<PhotoPage />} />
          </>
        ) : (
          <Route path="*" element={
            <>
              <h2>Niste logirani, logirajte se</h2>
              <LoginPage onLoggedIn={onLoggedIn} />
            </>
          } />
        )}
      </Routes>
    </Router>
  );
}

function NotFound(props: {}) {
    return (<h1>Not found</h1>);
}

export default App;
